import React, { useState, useEffect} from 'react'
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DashAuthWrapper from './../components/DashAuthWrapper'
import {  fetchServicesStart } from './../redux/VendorServices/vendor.actions';
import { fetchApptsStart, addApptStart, deleteApptStart } from '../redux/Appointments/appts.actions';
import Button from './../components/forms/Button';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {format} from 'date-fns'

const mapState = ({ apptsData, vendorsData, user }) => ({
	appts: apptsData.appts,
  	services: vendorsData.services,
  	currentUser: user.currentUser,
	customers: user.customers,
	
})

const VendorApptDetails = props => {
	const { appts, services, currentUser, customers } = useSelector(mapState);
	const dispatch = useDispatch();
	const { custID } = useParams();
	const [startDate, setStartDate] = useState(new Date());
	const [custsID, setCustID] = useState(custID);
	const [vendorsID, setVendorID] = useState(currentUser.id);
	const [vendorsName, setVendorName] = useState(currentUser.displayName);
	const [vendorsPhone, setVendorsPhone] = useState(currentUser.phone);
	const [apptDetails, setApptDetails] = useState('');
	const history = useHistory();
	
	const { apptData } = appts;
	const { serviceData } = services;
	const { customersData } = customers;

	useEffect(() => {
		dispatch(
			fetchServicesStart()
		);
		dispatch(
			fetchApptsStart()
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []);

	

	//only show subscribed customers && filter by custID
	const customer = [];
	if(Array.isArray(customersData)){
		for(let i = 0; i < customersData.length; i++){
			if(customersData[i].subscribed && customersData[i].documentID === `${custID}`){
				customer.push(customersData[i]);
			}
		}
	}
	const [custName, setCustName] = useState(customer[0].displayName)
	;
	const [custAddress, setCustAddress] = useState(customer[0].fullAddress)
	;
	const [productName, setProductName] = useState(serviceData[0].productName)
	

	const resetForm = () => {
		setStartDate(new Date());
		setProductName(serviceData[0].productName);
		setCustID(custID);
		setCustName(customer[0].displayName);
		setCustAddress(customer[0].fullAddress);
		setVendorID(currentUser.id);
		setVendorName(currentUser.displayName);
		setVendorsPhone(currentUser.phone);
		setApptDetails('')
	};

	const handleSubmit = e => {
		e.preventDefault();
	
		dispatch(
			addApptStart({
				startDate,
				productName,
				custsID,
				custName,
				vendorsID,
				vendorsName,
				custAddress,
				vendorsPhone,
				apptDetails
			  })
		);
		resetForm();
	
	};

	
	//filter appts by custID
	const custAppts = [];
	if(Array.isArray(apptData)){
		for(let i = 0; i < apptData.length; i++){
			if(apptData[i].custsID === `${custID}`){
				custAppts.push(apptData[i]);
			}
			
		}
	}

	const congfigAuthWrapper = {
		headline: `Create Appointment for ${customer[0].displayName}`
	}
	
	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
			<h4>Select service, date, and add details. Then click "ADD" for new appointment.</h4>
			<div className="pb-5 mt-5 submitAppt">
				<form onSubmit={handleSubmit} className="apptForm">
					<div className="row mb-5">
						<div className="col-xs-12 col-6 pt-1 pb-1 ">
							<select name="services"  className="p-1"  onChange={e => setProductName(e.target.value)}>
								{(Array.isArray(serviceData) && serviceData.length > 0) && serviceData.map((products, index) => {
								const {
									productName
								} = products;
								
								return (
								<option value={productName} name={productName} key={index}>{productName}</option>
									
								)
								
								})}
								
							</select>
						</div>
						<div className="col-xs-12 col-6 pt-1 pb-1 ">
							<DatePicker className="p-1" selected={startDate} onChange={date => setStartDate(date)} />
						</div>
					</div>
					<div className="pb-1">
						<label htmlFor="Description" className="text-dark">Details</label><br></br>
						<textarea value={apptDetails} id="Description" name="Description" rows="2" cols="50" onChange={e => setApptDetails(e.target.value)}></textarea>
					</div>
					<div className="row">
						<div className="col-sm-12 col-lg-12 pt-1 pb-1">
							<Button type="submit">
								ADD
							</Button>
						</div>
					</div>
				</form>
			</div>
			<div className="manageAppts mt-5">
				<hr></hr>
				<h2 className="text-primary">Manage Appointments</h2>
				<hr></hr>
				<div className="cart apptDetails">
					<table border="0" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td>
									<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
										<tbody >
										<tr >
											<th className="pr-0">
											Service
											</th>
										
											<th className="pl-0 pr-o ml-0">
											Date
											</th>
										
											<th >
											</th>

											<th >
											</th>
											
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td>
									<table className="convoResults" border="0" cellPadding="5" cellSpacing="0">
									<tbody>
									
										{(Array.isArray(custAppts) && custAppts.length > 0) && custAppts.map((appts, index) => {
											const {
												startDate,
												productName,
												documentID, 
											} = appts;
											
											return (
												<tr key={index}>
												
												<td>
													{productName}
												</td>
												<td >
												{format(startDate.toDate(), 'MMM dd, yyyy ')} 
												</td>
												<td className="text-right">
													<Button className="btn-alt mx-3 vendEditBtns" onClick={() => history.push(`/vendorEditAppt/${documentID}`)}>
														Details
													</Button>
												</td>
												<td className="text-right">
													<Button className="btn vendEditBtns" onClick={() => dispatch(deleteApptStart(documentID))}>
														Delete
													</Button>
												</td>
												
												</tr>
											)
										})}

									</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</DashAuthWrapper>


		
	)
}

export default VendorApptDetails;